module.exports = __webpack_public_path__ + "img/logo.c024fb18.png";